import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';

import {
  IndirectTaxProductTaxCodesResponse,
  UseIndirectTaxProductTaxCodesParams,
} from './types';

export function useIndirectTaxProductTaxCodes({
  token,
  filters,
}: UseIndirectTaxProductTaxCodesParams) {
  const query = new URLSearchParams();

  if (filters.corporationId !== undefined) {
    query.append('corporationId', filters.corporationId.toString());
  }

  const { data, mutate, error, isLoading } = useSWR<IndirectTaxProductTaxCodesResponse>(
    filters.corporationId !== undefined
      ? `new-sales-tax/products/taxCodes?${query}`
      : null,
    SWRFetcher({ method: 'GET' }, token),
    { revalidateOnFocus: false }
  );

  return {
    data: data?.data?.taxCodes,
    mutate,
    error,
    isLoading,
  };
}
